import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useDirectLookupRehireDriver = () => {
    const request = useHttps();
    const [loading, setLoading] = useState(false);
    // const { ninNumber } = useParams();

    const onHireDriverError = (err: AxiosError<ErrorHttpResponse>) => {
        toast.error(
            err?.response?.data?.message ?? 'Something went wrong while creating drivers account.',
        );
    };

    const onHireDriverSuccess = (callbackFn: () => void) => ({
        data,
        message,
    }: SuccessHttpResponse<any>) => {
        toast.success(message || 'Driver hired successfully');
        callbackFn();
    };

    const rehireDriver = (data: any, callbackFn: () => void) => {
        const formData = new FormData();
        // Object.keys(data).forEach(key => {
        //     const formKey = key === 'id' ? 'driverId' : key;
        //     formData.append(formKey, data[key]);
        // });

        formData.append("driverId", data['driverId']);
        formData.append("employmentType", data['employmentType']);


        const url: HttpConfig = {
            url: 'api/v1/dispatchers/re-hire',
            method: 'post',
            data: formData
        };

        request(url, onHireDriverSuccess(callbackFn), setLoading, onHireDriverError);
    };

    return { rehireDriver, loading };
};

export default useDirectLookupRehireDriver;
